export var SOURCE_FILE = 'main.json';
